<script setup>
import { onMounted, onUnmounted, onUpdated, computed } from 'vue';
import { transformOptions, transformValue, SelectProps, initSelect2, destroySelect2 } from '../helper/select';

// Define variables.
const props = defineProps(SelectProps);
const selectedValue = computed(() => transformValue(props)); // We use computed to transform the value when the props.value is changed.
const transformedOptions = computed(() => transformOptions(props)); // We use computed to transform the options when the props.options is changed.

// Initialize select2 when the component is mounted
onMounted(() => {
  initSelect2(props);
});

// Destroy select2 when the component is unmounted
onUnmounted(() => {
  destroySelect2(props);
});
</script>

<template>
  <select
    :id="`field_${props.id}`"
    :name="props.name"
    :class="props.inputClass"
    :data-selected="selectedValue"
    @change="$emit('change')"
  >
    <template v-for="option in transformedOptions" :key="option.id">
      <optgroup v-if="option.children" :label="option.text">
        <option
          v-for="child in option.children"
          :key="child.id"
          :value="child.id"
          :selected="child.id === selectedValue"
          :disabled="child.disabled"
        >
          {{ child.text }}
        </option>
      </optgroup>
      <option v-else :value="option.id" :selected="option.id === selectedValue" :disabled="option.disabled">
        {{ option.text }}
      </option>
    </template>
  </select>
</template>
